import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

import useStyles from './MatrixHeaderStyles';

export const ASCENDING = 'asc';
export const DESCENDING = 'desc';
export const NONE = 'none';

export default function Sorter(props) {
    const classes = useStyles();
    const { sort } = props;

    if (sort === ASCENDING) {
        return <ArrowUpwardIcon />;
    }

    if (sort === DESCENDING) {
        return <ArrowDownwardIcon />;
    }

    return <div className={classes.noSortContainer} />;
}
